import { Navigate, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { AdminLogin } from '@/components/AdminLogin';
import { usePageMeta } from '@/hooks/usePageMeta';
import { ADMIN_TOKEN_KEY } from '@/utils/adminAuth';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  usePageMeta({ title: 'Operations Sign In | Next Leap Inc', description: 'Restricted sign-in for Next Leap Inc staff.', robots: 'noindex,nofollow' });

  if (localStorage.getItem(ADMIN_TOKEN_KEY)) return <Navigate to="/admin" replace />;

  const handleSuccess = (token) => {
    localStorage.setItem(ADMIN_TOKEN_KEY, token);
    toast.success('Signed in');
    navigate('/admin', { replace: true });
  };

  return <AdminLogin onSuccess={handleSuccess} />;
};

export default AdminLoginPage;
